import Server from '../lib/server.js';

export default class LmsServer extends Server {
    getOffers(data, callback) {
        if (!data.pageNumberChanged) {
            delete data.pageNumber;
        }
        delete data.pageNumberChanged;
        this.loadJSON('result', data, callback);
    }

    sendSaveSearch(data, callback) {
        this.postJSON('../../travel-api/lms/save-search', data, callback);
    }
}
